import React from 'react';
import PropTypes from 'prop-types';
import getTripOriginDetails from 'sharedWebpack/IBE/helpers/getTripOriginDetails';
import getTripDestinationDetails from 'sharedWebpack/IBE/helpers/getTripDestinationDetails';
import JourneySummaryIndicator from '.';

const JourneySummaryIndicatorWrapper = ({ trips, airports, isTripTypeVisible }) => {
  const originDetails = getTripOriginDetails(trips, airports);
  const destinationDetails = getTripDestinationDetails(trips, airports);

  return (
    <JourneySummaryIndicator
      trips={trips}
      originCountryInfo={originDetails}
      destinationCountryInfo={destinationDetails}
      isTripTypeVisible={isTripTypeVisible}
    />
  );
};

const AirportsShape = PropTypes.shape({
  [PropTypes.string]: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

JourneySummaryIndicatorWrapper.defaultProps = {
  isTripTypeVisible: true,
};

JourneySummaryIndicatorWrapper.propTypes = {
  trips: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  airports: AirportsShape.isRequired,
  isTripTypeVisible: PropTypes.bool,
};

export default JourneySummaryIndicatorWrapper;
